module.exports = __webpack_public_path__ + "91ae827aa880d02ea567979add1da58c.woff2";